import React from "react";
import { Grid, Input } from "@masterteam/mt-design-react";

import { ReactComponent as ArrowDown } from "../../../assets/images/arrow-down-curve.svg";

const { Row, Col } = Grid;

function ListItem({
  isSelected,
  selectable,
  title,
  value,
  onValueChange,
  item,
  disabled = false,
  onItemSelect,
}) {
  function onChange(e) {
    const { value } = e.currentTarget;

    if (onValueChange) onValueChange(item?.ID, Number(value));
  }

  function onSelect() {
    if (onItemSelect) onItemSelect(item);
  }

  return (
    <div className="weight-kpis__list__item">
      <Row gap={0}>
        <Col span={20}>
          <div
            className="weight-kpis__list__item__title"
            style={{
              borderInlineStartColor:
                isSelected && selectable ? "var(--primary-color)" : undefined,
              cursor: selectable ? "pointer" : undefined,
              fontWeight: isSelected ? "bold" : undefined,
            }}
            onClick={onSelect}
          >
            {title}
          </div>
        </Col>
        <Col span={4}>
          <div className="weight-kpis__list__item__input-container">
            <Input
              Icon={() => <span className="percentage">%</span>}
              type="number"
              value={value}
              onChange={onChange}
              disabled={disabled}
              min={0}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ListItem;
